import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "dfr_access_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            setToken(null);
            if (typeof window !== "undefined" && window.location.pathname !== "/login") {
                window.location.replace("/login");
            }
        }
        return Promise.reject(err);
    }
);

export default api;

// Handles FastAPI validation error arrays alongside plain string details.
export const formatApiError = (err) => {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Request failed";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join("; ");
    if (detail?.msg) return String(detail.msg);
    return JSON.stringify(detail);
};
